import { type PropsWithChildren, useEffect } from "react";
import { useAuth } from "@/auth/useAuth.ts";

export function LoginResolver({ children }: PropsWithChildren) {
  const { isAuthenticated, login } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) void login();
  }, [isAuthenticated, login]);

  if (!isAuthenticated) return null;

  return <>{children}</>;
}
